let _env = {};
async function tryFetch(url) {
    try {
        const res = await fetch(url);
        if (res.ok)
            return (await res.json());
    }
    catch {
        // ignore
    }
    return null;
}
/**
 * Load runtime environment config. Resolution order:
 *   1. /environment.local.json  — local developer overrides (gitignored, never committed)
 *   2. /environment.{ENV}.json  — environment-specific: dev | stg | prod
 *   3. /environment.json        — base fallback / empty template
 *
 * REACT_APP_ENV is injected at build time by webpack DefinePlugin.
 * Set it via shell before building: REACT_APP_ENV=stg npm run build
 */
export async function loadEnvironment() {
    const appEnv = process.env.REACT_APP_ENV;
    _env =
        (await tryFetch('/environment.local.json')) ??
            (appEnv ? await tryFetch(`/environment.${appEnv}.json`) : null) ??
            (await tryFetch('/environment.json')) ??
            {};
}
export function getEnv(key) {
    return _env[key] ?? '';
}
